import React from 'react'
import Paper from '@mui/material/Paper'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'
import Button from '@mui/material/Button'
import IconButton from '@mui/material/IconButton'
import InputBase from '@mui/material/InputBase'
import SearchIcon from '@mui/icons-material/Search'

import { LIST_FILTER_SEARCH_FIELD_SX, LIST_FILTER_SEARCH_BUTTON_SX, ListFilterBar, ListFilterForm } from '../../component/ListFilterLayout'
import Pagination from '../../component/Pagination'
import { FORM_COMPACT_ACTION_BUTTON_SX } from '../../component/BottomButtonGroup'

export function AppPushMeetTargetTable({
    rows = [],
    totalCount = 0,
    curPage = 1,
    offset = 5,
    setCurPage,
    selectedMeetId,
    imageHeader,
    titleHeader,
    rowKey,
    imageSrc,
    onSelect,
    saving,
}) {
    return (
        <Paper sx={{ p: 2, display: 'flex', flexDirection: 'column' }}>
            <Table size="small">
                <caption>Total Count: {totalCount}</caption>
                <TableHead>
                    <TableRow>
                        <TableCell>No</TableCell>
                        <TableCell>{imageHeader}</TableCell>
                        <TableCell>{titleHeader}</TableCell>
                        <TableCell align="right">Action</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {rows.map((row) => (
                        <TableRow key={rowKey(row)} sx={{ backgroundColor: row.meetId === selectedMeetId ? 'silver' : '' }}>
                            <TableCell>{row.rownum}</TableCell>
                            <TableCell><img className="listImg" src={imageSrc(row)} alt="" /></TableCell>
                            <TableCell>{row.title}</TableCell>
                            <TableCell align="right">
                                <Button
                                    variant="contained"
                                    color="success"
                                    size="small"
                                    sx={FORM_COMPACT_ACTION_BUTTON_SX}
                                    onClick={() => onSelect(row)}
                                    disabled={saving}
                                >
                                    선택
                                </Button>
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
            {totalCount > 0 && <Pagination curPage={curPage} offset={offset} totalCount={totalCount} setCurPage={setCurPage} />}
        </Paper>
    )
}

export function AppPushCoupangTargetTable({
    rows = [],
    captionTotalCount = 0,
    totalCount = 0,
    curPage = 1,
    offset = 5,
    setCurPage,
    selectedCoupangId,
    searchText = '',
    onSearchTextChange,
    onSearchSubmit,
    onSelect,
    saving,
}) {
    return (
        <Paper sx={{ p: 2, display: 'flex', flexDirection: 'column' }}>
            <ListFilterBar>
                <ListFilterForm onSubmit={onSearchSubmit}>
                    <InputBase
                        sx={LIST_FILTER_SEARCH_FIELD_SX}
                        placeholder="상품명"
                        type="search"
                        name="searchText"
                        value={searchText}
                        onChange={onSearchTextChange}
                        disabled={saving}
                    />
                    <IconButton type="submit" sx={LIST_FILTER_SEARCH_BUTTON_SX} aria-label="search" disabled={saving}>
                        <SearchIcon />
                    </IconButton>
                </ListFilterForm>
            </ListFilterBar>
            <Table size="small">
                <caption>Total Count: {captionTotalCount}</caption>
                <TableHead>
                    <TableRow>
                        <TableCell>No</TableCell>
                        <TableCell>상품이미지</TableCell>
                        <TableCell>카테고리</TableCell>
                        <TableCell>하위카테고리</TableCell>
                        <TableCell>상품명</TableCell>
                        <TableCell align="center">url</TableCell>
                        <TableCell align="right">Action</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {rows.map((row) => (
                        <TableRow key={row.coupangId} sx={{ backgroundColor: row.coupangId === selectedCoupangId ? 'silver' : '' }}>
                            <TableCell>{row.rownum}</TableCell>
                            <TableCell><img className="listImg" src={row.productImage} alt="" /></TableCell>
                            <TableCell>{row.keyword1}</TableCell>
                            <TableCell>{row.keyword2}</TableCell>
                            <TableCell>{row.productName}</TableCell>
                            <TableCell>
                                <Button
                                    disabled={saving}
                                    onClick={() => {
                                        window.open(row.landingUrl, '_blank', 'noopener noreferrer')
                                    }}
                                >
                                    Link
                                </Button>
                            </TableCell>
                            <TableCell align="right">
                                <Button
                                    variant="contained"
                                    color="success"
                                    size="small"
                                    sx={FORM_COMPACT_ACTION_BUTTON_SX}
                                    onClick={() => onSelect(row)}
                                    disabled={saving}
                                >
                                    선택
                                </Button>
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
            {totalCount > 0 && <Pagination curPage={curPage} offset={offset} totalCount={totalCount} setCurPage={setCurPage} />}
        </Paper>
    )
}
